import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "drawer-header" }
const _hoisted_2 = { class: "title-main" }
const _hoisted_3 = { class: "title-warning" }

import { ref, PropType, computed, watch, Ref } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import SelectOperator from '@/components/SelectOperator.vue'
import ActivityTmplItems from './ActivityTmplItems.vue'
import { upsertActivity } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Activity, AmountType, ActivityType } from '@/types/types'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { dateFormat, dateFormatRFC3339 } from '@/common/tools'
import FormRulesFactory from '@/common/formRules'


import { defineComponent, nextTick } from 'vue'

const __default__ = defineComponent({
  name: 'ActivityDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const activityFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['operatorId', 'type'], 'selectNone', 'selectNone'),
  ...FormRulesFactory.generateCustomRules(
    ['name', 'beginTime', 'endTime'],
    'inputEmpty',
    'inputInvalid',
  ),
})
const activityTmplItems = ref()
const { activityTypes } = useProtocolEnums()

const { t, tl } = useI18nTl('Operation')



let subsForm = ref()
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    })
  })
}

const record = ref<Record<string, any>>({
  type: ActivityType.AT_RECHARGER_GIFT,
  tmpl: {
    amountType: AmountType.AT_TOTAL_AMOUNT,
    items: [],
  },
})
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      record.value = {
        type: ActivityType.AT_RECHARGER_GIFT,
        tmpl: {
          amountType: AmountType.AT_TOTAL_AMOUNT,
          items: [],
        },
      }
    }
  },
})

const submit = async () => {
  if (activityTmplItems.value) activityTmplItems.value.validate()
  await subsForm.value?.validate()

  // record.value.tmpl.amountType = AmountType.AT_TOTAL_AMOUNT
  upsertActivity(record.value).then((res: any) => {
    if (props.isEdit) {
      ElMessage.success(t(`Base.editSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    showDialog.value = false
    emit('submitted')
  })
}
watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      record.value.id = props.info?.id
      record.value.name = props.info?.name
      record.value.type = props.info?.type
      record.value.isOpen = props.info?.isOpen
      record.value.beginTime = dateFormatRFC3339(Number(props.info?.beginTime * 1000))
      record.value.endTime = dateFormatRFC3339(Number(props.info?.endTime * 1000))
      record.value.useBeginTime = dateFormatRFC3339(Number(props.info?.useBeginTime * 1000))
      record.value.useEndTime = dateFormatRFC3339(Number(props.info?.useEndTime * 1000))
      record.value.description = props.info?.description
      record.value.operatorId = props.info?.operatorId
      record.value.operatorName = props.info?.operatorName
      record.value.tmpl = props.info?.tmpl
    } else {
      record.value = {
        type: ActivityType.AT_RECHARGER_GIFT,
        tmpl: {
          amountType: AmountType.AT_TOTAL_AMOUNT,
          items: [],
        },
      }
    }
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.isEdit ? _unref(tl)('editDiscountsActivity') : _unref(tl)('addDiscountsActivity')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(props.isEdit ? _unref(tl)('editActivityDesc') : _unref(tl)('addActivityDesc')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[11] || (_cache[11] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.saveChanges') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: activityFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('activityName'),
                    prop: "name",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.name) = $event)),
                        disabled: props.isEdit
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      (!props.isEdit)
                        ? (_openBlock(), _createBlock(SelectOperator, {
                            key: 0,
                            modelValue: record.value.operatorId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.operatorId) = $event))
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            modelValue: record.value.operatorName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.operatorName) = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('activityType'),
                    prop: "type",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.type) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activityTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value,
                              disabled: props.isEdit
                            }, null, 8, ["label", "value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.isEnabled'),
                    prop: "isOpen"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: record.value.isOpen,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.isOpen) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.beginTime'),
                    prop: "beginTime",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: record.value.beginTime,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.beginTime) = $event)),
                        type: "datetime",
                        placeholder: _ctx.$t('Base.beginTime'),
                        clearable: "",
                        disabled: props.isEdit
                      }, null, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.endTime'),
                    prop: "endTime",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: record.value.endTime,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.endTime) = $event)),
                        type: "datetime",
                        placeholder: _ctx.$t('Base.endTime'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              (record.value.type != _unref(ActivityType).AT_RECHARGER_GIFT)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('Operation.discountUseBeginTime'),
                        prop: "useBeginTime"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: record.value.useBeginTime,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.useBeginTime) = $event)),
                            type: "datetime",
                            placeholder: _ctx.$t('Operation.discountUseBeginTime'),
                            clearable: "",
                            disabled: props.isEdit
                          }, null, 8, ["modelValue", "placeholder", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.value.type != _unref(ActivityType).AT_RECHARGER_GIFT)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('Operation.discountUseEndTime'),
                        prop: "useEndTime"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: record.value.useEndTime,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.useEndTime) = $event)),
                            type: "datetime",
                            placeholder: _ctx.$t('Operation.discountUseEndTime'),
                            clearable: "",
                            disabled: props.isEdit
                          }, null, 8, ["modelValue", "placeholder", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.desc'),
                    prop: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: record.value.description,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((record.value.description) = $event)),
                        rows: 2
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 16 }, {
                default: _withCtx(() => [
                  (record.value.type != _unref(ActivityType).AT_RECHARGER_GIFT)
                    ? (_openBlock(), _createBlock(_component_el_radio_group, {
                        key: 0,
                        modelValue: record.value.tmpl.amountType,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((record.value.tmpl.amountType) = $event)),
                        disabled: props.isEdit
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, {
                            label: _unref(AmountType).AT_ELECTRIC_AMOUNT
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('Operation.elecFee')), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_radio, {
                            label: _unref(AmountType).AT_SERVICE_AMOUNT
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('Operation.settleSrvAmount')), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_radio, {
                            label: _unref(AmountType).AT_TOTAL_AMOUNT
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('Operation.settleAmount')), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (record.value.type != _unref(ActivityType).AT_RECHARGER_GIFT)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('Operation.selectDiscountAmountType')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(ActivityTmplItems, {
                    ref_key: "activityTmplItems",
                    ref: activityTmplItems,
                    list: record.value.tmpl.items,
                    activityType: record.value.type,
                    isEdit: props.isEdit,
                    amountType: record.value.tmpl.amountType
                  }, null, 8, ["list", "activityType", "isEdit", "amountType"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})